/** TEMPORARY — delete this file and its call sites when QA notice is no longer needed. */

export const INVOICE_PAYMENT_QA_NOTICE_MESSAGE =
  'QA notice: All text and content shown on this page are temporary and must be reviewed before release. ' +
  'Please submit change requests for anything that needs updating.';

/**
 * Shows the temporary QA notice in the page Warning banner (not Error, not SweetAlert).
 */
export function showInvoicePaymentQaNotice(showBanner: (message: string) => void): void {
  if (typeof showBanner === 'function') {
    showBanner(INVOICE_PAYMENT_QA_NOTICE_MESSAGE);
  }
}
